"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ETemplateType;
(function (ETemplateType) {
    ETemplateType["LETTER"] = "LETTER";
    ETemplateType["MESSAGE"] = "MESSAGE";
    ETemplateType["LETTER_PDF"] = "LETTER_PDF";
})(ETemplateType = exports.ETemplateType || (exports.ETemplateType = {}));
var ETemplateLevel;
(function (ETemplateLevel) {
    ETemplateLevel["CHAIN"] = "CHAIN";
    ETemplateLevel["STATEMENT"] = "STATEMENT";
})(ETemplateLevel = exports.ETemplateLevel || (exports.ETemplateLevel = {}));
;
var ETemplateCategory;
(function (ETemplateCategory) {
    ETemplateCategory["RESIDENT"] = "RESIDENT";
    ETemplateCategory["FACILITY"] = "FACILITY";
    ETemplateCategory["PAYMENT_AND_BALANCE"] = "PAYMENT_AND_BALANCE";
})(ETemplateCategory = exports.ETemplateCategory || (exports.ETemplateCategory = {}));
;
var ETemplateField;
(function (ETemplateField) {
    ETemplateField["FACILITY_NAME"] = "FACILITY_NAME";
    ETemplateField["FACILITY_EMAIL"] = "FACILITY_EMAIL";
    ETemplateField["FACILITY_PHONE"] = "FACILITY_PHONE";
    ETemplateField["FACILITY_WEBSITE"] = "FACILITY_WEBSITE";
    ETemplateField["FACILITY_ADDRESS"] = "FACILITY_ADDRESS";
    ETemplateField["BILLING_CONTACT_NAME"] = "BILLING_CONTACT_NAME";
    ETemplateField["BILLING_CONTACT_EMAIL"] = "BILLING_CONTACT_EMAIL";
    ETemplateField["BILLING_CONTACT_PHONE"] = "BILLING_CONTACT_PHONE";
    ETemplateField["RESIDENT_FIRST_NAME"] = "RESIDENT_FIRST_NAME";
    ETemplateField["RESIDENT_LAST_NAME"] = "RESIDENT_LAST_NAME";
    ETemplateField["RESIDENT_ID"] = "RESIDENT_ID";
    ETemplateField["RESIDENT_STATUS"] = "RESIDENT_STATUS";
    ETemplateField["PRIMARY_PAYMENT_METHOD"] = "PRIMARY_PAYMENT_METHOD";
    ETemplateField["MAILING_CONTACT_NAME"] = "MAILING_CONTACT_NAME";
    ETemplateField["MAILING_CONTACT_FIRST_NAME"] = "MAILING_CONTACT_FIRST_NAME";
    ETemplateField["MAILING_CONTACT_LAST_NAME"] = "MAILING_CONTACT_LAST_NAME";
    ETemplateField["MAILING_CONTACT_ADDRESS"] = "MAILING_CONTACT_ADDRESS";
    ETemplateField["OPEN_ITEM_DETAILS"] = "OPEN_ITEM_DETAILS";
    ETemplateField["OPEN_ITEM_SUMMARY"] = "OPEN_ITEM_SUMMARY";
    ETemplateField["TOTAL_BALANCE"] = "TOTAL_BALANCE";
})(ETemplateField = exports.ETemplateField || (exports.ETemplateField = {}));
;
exports.TEMPLATE_FIELDS_MAP = {
    [ETemplateField.FACILITY_NAME]: '{FacilityName}',
    [ETemplateField.FACILITY_EMAIL]: '{FacilityEmail}',
    [ETemplateField.FACILITY_ADDRESS]: '{FacilityAddress}',
    [ETemplateField.FACILITY_PHONE]: '{FacilityPhone}',
    [ETemplateField.FACILITY_WEBSITE]: '{FacilityWebsite}',
    [ETemplateField.BILLING_CONTACT_EMAIL]: '{BillingContactEmail}',
    [ETemplateField.BILLING_CONTACT_NAME]: '{BillingContactName}',
    [ETemplateField.BILLING_CONTACT_PHONE]: '{BillingContactPhone}',
    [ETemplateField.RESIDENT_FIRST_NAME]: '{ResidentFirstName}',
    [ETemplateField.RESIDENT_LAST_NAME]: '{ResidentLastName}',
    [ETemplateField.RESIDENT_ID]: '{ResidentID}',
    [ETemplateField.RESIDENT_STATUS]: '{ResidentStatus}',
    [ETemplateField.PRIMARY_PAYMENT_METHOD]: '{PrimaryPaymentMethod}',
    [ETemplateField.MAILING_CONTACT_NAME]: '{MailingContactName}',
    [ETemplateField.MAILING_CONTACT_FIRST_NAME]: '{MailingContactFirstName}',
    [ETemplateField.MAILING_CONTACT_LAST_NAME]: '{MailingContactLastName}',
    [ETemplateField.MAILING_CONTACT_ADDRESS]: '{MailingContactAddress}',
    [ETemplateField.OPEN_ITEM_DETAILS]: '{"TemplateType":"Open Item Details"}',
    [ETemplateField.OPEN_ITEM_SUMMARY]: '{"TemplateType":"Open Item Summary"}',
    [ETemplateField.TOTAL_BALANCE]: '{"TemplateType":"Total Balance"}'
};
exports.UPLOADED_PDF_TEMPLATE_PATH = '/pdf-letters/';
